import { Button, useModal } from "@alpacahq/ui/old";

export interface UseCancelModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const useCancelModal = ({ onCancel, onConfirm }: UseCancelModalProps) =>
  useModal({
    title: "Are you sure you want to exit?",
    content:
      "If you leave, you will need to finish the onboarding at another time. Do you wish to confirm this action?",
    controls: (
      <div className="flex items-center justify-end gap-4">
        <Button variant="v2/stroke" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="v2/filled" onClick={onConfirm}>
          Yes, exit
        </Button>
      </div>
    ),
  });
